global.$$require_external = typeof require !== "undefined" ? require : () => null;